import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Text } from '@paygreen/paygreen-ui';
import { ModalForm } from '../../components';

const AddCmsProduct = ({ isOpen, t }) => {
    return (
        <ModalForm
            modalTitle={t('matching.addForm.modalTitle')}
            blockWidth="md"
            paddingLateral="md"
            hasCloseCross={false}
            isOpen={isOpen}
        >
            <Text>Csm Mode</Text>
        </ModalForm>
    );
};

AddCmsProduct.propTypes = {
    /**
     * @description setOpen and isOpen are automatically received from ModalControl parent
     */
    setOpen: PropTypes.func,
    isOpen: PropTypes.bool,
};

AddCmsProduct.defaultProps = {};

export default withTranslation('common')(AddCmsProduct);
